import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import { logOut } from "../../../utils/logOut"
import TranslatedText from "../../../utils/Translate"
import { Paper, Slider } from "@mui/material"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function ConversationTemplate() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [recognitionVendors, setRecognitionVendors] = useState([])
    const [synthVoices, setSynthVoices] = useState([])
    const [voices, setVoices] = useState([])
    const [backgroundSounds, setBackgroundSounds] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title

    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit conversation Template` : type === 'add' ? 'Add conversation template' : 'Copy conversation template'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get contact group
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setConversationTemplateData({ ...response.data[0], tempo: response.data[0].tempo != null ? response.data[0].tempo : '1', pitch: response.data[0].pitch != null ? response.data[0].pitch : '0', tempoprerecorded: response.data[0].tempoprerecorded != null ? response.data[0].tempoprerecorded : '1', pitchprerecorded: response.data[0].pitchprerecorded != null ? response.data[0].pitchprerecorded : '0', conversationtemplatename: type == 'copy' ? response.data[0].conversationtemplatename + ' - COPY' : response.data[0].conversationtemplatename, conversationtemplatecode: type == 'copy' ? response.data[0].conversationtemplatecode + ' - COPY' : response.data[0].conversationtemplatecode })
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                ...data,
                "voice": data.voicecode,
                'voiceprerecorded': data.prerecordedvoicename
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create contact group
    async function copyData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/conversationtemplate/${id}`, {
                ...data,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit contact group
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/conversationtemplate/${id}`, {
                ...data,
                "voice": data.voicecode,
                'voiceprerecorded': data.prerecordedvoicename
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [ConversationTemplateData, setConversationTemplateData] = useState<any>(type === 'edit' ? [] :
        {
            "id": null,
            "conversationtemplatecode": null,
            "conversationtemplatename": null,
            'recognitionvendor': 'INTERNAL',
            'vad_type': 'VAD_AMPLITUDE',
            'showsetuptopartner': '1',
            "partner": null,
            'prerecordedvoicename': 'alla',
            'pitchprerecorded': '0',
            "tempoprerecorded": '1',
            'voicecode': 'alena',
            "emotion": 'neutral',
            "speed": '1.0',
            "examplesoundcode": null,
            "pitch": '0',
            "tempo": '1',
            'backgroundsoundcode': null,
            "voicecloningvendor": null
        }
    )

    //Get partners for Select field
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSPartners(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get recognition vendors for Select field
    async function getRecognitionVendors(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/recognition`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setRecognitionVendors(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get voices for Select field
    async function getSynthVoices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/synthesizedvoices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSynthVoices(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get voices for Select field
    async function getVoices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/prerecordedvoices`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setVoices(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get bgsounds for Select field
    async function getBackgroundSounds(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/backgroundsounds`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setBackgroundSounds(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }



    //On load if URL params contains type=edit - get contactgroup data, if accesslevel = 5 - get partners for Select field
    useEffect(() => {
        (type === 'edit' || type === 'copy') && fetchData()
        accesslevel === "5" && getPartners()
        type != 'copy' && getSynthVoices()
        type != 'copy' && getVoices()
        type != 'copy' && getBackgroundSounds()
        type != 'copy' && getRecognitionVendors()
        console.log(ConversationTemplateData);
    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: '100%', maxWidth: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Paper elevation={3} sx={{ width: '100%', maxWidth: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2, padding: 2 }}>
                        <Typography variant="h6">
                            <TranslatedText text={type === 'copy' ? 'General Template Copying Options' : 'General Template Options'} />
                        </Typography>
                        <TextField sx={{ minWidth: 223, width: '100%' }} error={ConversationTemplateData.conversationtemplatecode === null} onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, conversationtemplatecode: e.target.value !== '' ? e.target.value : null })} value={ConversationTemplateData.conversationtemplatecode || ''} variant="outlined" size="small" label={<><TranslatedText text={'Code'} />*</>} />
                        <TextField sx={{ minWidth: 223, width: '100%' }} onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, conversationtemplatename: e.target.value !== '' ? e.target.value : null })} value={ConversationTemplateData.conversationtemplatename || ''} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                        {type != 'copy' && <><FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Recognition vendor"} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, recognitionvendor: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.recognitionvendor || ''} variant="outlined" size="small" label={<TranslatedText text={"Recognition vendor"} />} >
                                <MenuItem value={'GOOGLE'}>GOOGLE</MenuItem>
                                <MenuItem value={'YANDEXv2'}>YANDEXv2</MenuItem>
                                <MenuItem value={'YANDEXv3'}>YANDEXv3</MenuItem>
                                {
                                    recognitionVendors.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.name}>{el.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                            <FormControl sx={{ width: '100%' }}>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Voice activity detection"} /></InputLabel>
                                <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, vad_type: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.vad_type || ''} variant="outlined" size="small" label={<TranslatedText text={"Voice activity detection"} />} >
                                    <MenuItem value={'VAD_AMPLITUDE'}>VAD_AMPLITUDE</MenuItem>
                                    <MenuItem value={'VAD_COBRA'}>VAD_COBRA</MenuItem>
                                    <MenuItem value={'VAD_WEBRTC'}>VAD_WEBRTC</MenuItem>
                                </Select>
                            </FormControl> </>}
                        {Number(accesslevel) === 5 &&
                            <>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Available to partner"} /></InputLabel>
                                    <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, partner: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={"Available to partner"} />} >
                                        <MenuItem value={''}>Only Operators</MenuItem>
                                        <MenuItem value={'0'}>All</MenuItem>
                                        {
                                            partners.map((el: any) => {
                                                return (
                                                    <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </>
                        }
                        {(accesslevel === "5" && type != 'copy') && <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography><TranslatedText text={'Allow partner to edit template'} /></Typography>
                            <Switch onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, showsetuptopartner: ConversationTemplateData.showsetuptopartner == '0' ? '1' : '0' })} checked={Boolean(+ConversationTemplateData.showsetuptopartner)} />
                        </Box>}
                    </Paper>
                    {type != 'copy' && <Paper elevation={3} sx={{ width: '100%', maxWidth: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2, padding: 2 }}>
                        <Typography variant="h6">
                            <TranslatedText text={'Prerecorded voice'} />
                        </Typography>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Prerecorded voice name"} /></InputLabel>
                            <Select error={ConversationTemplateData.prerecordedvoicename == '' || ConversationTemplateData.prerecordedvoicename == null} sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, prerecordedvoicename: e.target.value !== '' ? e.target.value : null })} value={ConversationTemplateData.prerecordedvoicename || ''} variant="outlined" size="small" label={<TranslatedText text={'Prerecorded voice name'} />} >
                                {
                                    voices.map((el: any) => (
                                        <MenuItem key={el.id} value={el.voicecode}>{el.voicename}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Typography>
                            <TranslatedText text={'The tone of the pre-recorded voice'} />
                        </Typography>
                        <Slider
                            key={ConversationTemplateData.id + 'pp'}
                            onChange={(e: any) => setConversationTemplateData({ ...ConversationTemplateData, pitchprerecorded: (e.target.value).toString() })}
                            value={ConversationTemplateData.pitchprerecorded}
                            defaultValue={0}
                            valueLabelDisplay="auto"
                            step={5}
                            marks
                            track={false}
                            min={-500}
                            max={500}
                        />
                        <Typography>
                            <TranslatedText text={'The speed of the pre-recorded voice'} />
                        </Typography>
                        <Slider
                            key={ConversationTemplateData.id + 'tp'}
                            onChange={(e: any) => setConversationTemplateData({ ...ConversationTemplateData, tempoprerecorded: (e.target.value).toString() })}
                            value={ConversationTemplateData.tempoprerecorded}
                            defaultValue={1}
                            valueLabelDisplay="auto"
                            step={0.01}
                            marks
                            track={false}
                            min={0.1}
                            max={2}
                        />
                    </Paper>}
                    {type != 'copy' && <Paper elevation={3} sx={{ width: '100%', maxWidth: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2, padding: 2 }}>
                        <Typography variant="h6">
                            <TranslatedText text={'Synthesized voice'} />
                        </Typography>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Synthesized voice"} /></InputLabel>
                            <Select error={ConversationTemplateData.voicecode == '' || ConversationTemplateData.voicecode == null} sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, voicecode: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.voicecode || ''} variant="outlined" size="small" label={<TranslatedText text={"Synthesized voice"} />} >
                                {
                                    synthVoices.map((el: any) => (
                                        <MenuItem key={el.id} value={el.voicecode}>{el.voicename}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Emotion"} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, emotion: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.emotion || ''} variant="outlined" size="small" label={<TranslatedText text={"Emotion"} />} >
                                <MenuItem value={'neutral'}><TranslatedText text={"Neutral"} /></MenuItem>
                                <MenuItem value={'good'}><TranslatedText text={"Friendly"} /></MenuItem>
                                <MenuItem value={'evil'}><TranslatedText text={"Annoyed"} /></MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={"The speed of the synthesized voice when querying"} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, speed: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.speed || ''} variant="outlined" size="small" label={<TranslatedText text={'The speed of the synthesized voice when querying'} />} >
                                <MenuItem value={'0.1'}>0.1</MenuItem>
                                <MenuItem value={'0.2'}>0.2</MenuItem>
                                <MenuItem value={'0.3'}>0.3</MenuItem>
                                <MenuItem value={'0.4'}>0.4</MenuItem>
                                <MenuItem value={'0.5'}>0.5</MenuItem>
                                <MenuItem value={'0.6'}>0.6</MenuItem>
                                <MenuItem value={'0.7'}>0.7</MenuItem>
                                <MenuItem value={'0.8'}>0.8</MenuItem>
                                <MenuItem value={'0.9'}>0.9</MenuItem>
                                <MenuItem value={'1.0'}>1.0</MenuItem>
                                <MenuItem value={'1.1'}>1.1</MenuItem>
                                <MenuItem value={'1.2'}>1.2</MenuItem>
                                <MenuItem value={'1.3'}>1.3</MenuItem>
                                <MenuItem value={'1.4'}>1.4</MenuItem>
                                <MenuItem value={'1.5'}>1.5</MenuItem>
                                <MenuItem value={'1.6'}>1.6</MenuItem>
                                <MenuItem value={'1.7'}>1.7</MenuItem>
                                <MenuItem value={'1.8'}>1.8</MenuItem>
                                <MenuItem value={'1.9'}>1.9</MenuItem>
                                <MenuItem value={'2.0'}>2.0</MenuItem>
                                <MenuItem value={'2.1'}>2.1</MenuItem>
                                <MenuItem value={'2.2'}>2.2</MenuItem>
                                <MenuItem value={'2.3'}>2.3</MenuItem>
                                <MenuItem value={'2.4'}>2.4</MenuItem>
                                <MenuItem value={'2.5'}>2.5</MenuItem>
                                <MenuItem value={'2.6'}>2.6</MenuItem>
                                <MenuItem value={'2.7'}>2.7</MenuItem>
                                <MenuItem value={'2.8'}>2.8</MenuItem>
                                <MenuItem value={'2.9'}>2.9</MenuItem>
                                <MenuItem value={'3.0'}>3.0</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Example (distribution. frequency and volume) for voice synthesis'} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, examplesoundcode: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.examplesoundcode || ''} variant="outlined" size="small" label={<TranslatedText text={'Example (distribution. frequency and volume) for voice synthesis'} />} >
                                {
                                    backgroundSounds.map((el: any) => (
                                        <MenuItem key={el.id} value={el.id}>{el.code}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <Typography>
                            <TranslatedText text={'Post-processing - the tone of the synthesized voice'} />
                        </Typography>
                        <Slider
                            key={ConversationTemplateData.id + 'p'}
                            onChange={(e: any) => setConversationTemplateData({ ...ConversationTemplateData, pitch: (e.target.value).toString() })}
                            value={ConversationTemplateData.pitch}
                            defaultValue={0}
                            valueLabelDisplay="auto"
                            step={5}
                            marks
                            track={false}
                            min={-500}
                            max={500}
                        />
                        <Typography>
                            <TranslatedText text={'Post-processing - the speed of synthesized voice'} />
                        </Typography>
                        <Slider
                            key={ConversationTemplateData.id + 't'}
                            onChange={(e: any) => setConversationTemplateData({ ...ConversationTemplateData, tempo: (e.target.value).toString() })}
                            value={ConversationTemplateData.tempo}
                            defaultValue={1}
                            valueLabelDisplay="auto"
                            step={0.01}
                            marks
                            track={false}
                            min={0.1}
                            max={2}
                        />
                    </Paper>}
                    {type != 'copy' && <Paper elevation={3} sx={{ width: '100%', maxWidth: 600, display: "flex", mb: 2, flexWrap: "wrap", gap: 2, padding: 2 }}>
                        <Typography variant="h6">
                            <TranslatedText text={'General post-processing'} />
                        </Typography>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Background sound'} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, backgroundsoundcode: e.target.value !== '' ? e.target.value : null })} value={ConversationTemplateData.backgroundsoundcode || ''} variant="outlined" size="small" label={<TranslatedText text={'Background sound'} />} >
                                {
                                    backgroundSounds.map((el: any) => (
                                        <MenuItem key={el.id} value={el.id}>{el.code}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: '100%' }}>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Voice cloning service by phrase'} /></InputLabel>
                            <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setConversationTemplateData({ ...ConversationTemplateData, voicecloningvendor: e.target.value !== "" ? e.target.value : null })} value={ConversationTemplateData.voicecloningvendor || ''} variant="outlined" size="small" label={<TranslatedText text={'Voice cloning service by phrase'} />} >
                                <MenuItem value={''}><TranslatedText text={'No'} /></MenuItem>
                                <MenuItem value={'YANDEXv3'}>YANDEXv3</MenuItem>
                            </Select>
                        </FormControl>
                    </Paper>}
                </Box>
                <Button onClick={() => type === "edit" ? putData(ConversationTemplateData) : type === 'copy' ? copyData(ConversationTemplateData) : postData(ConversationTemplateData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={type === 'copy' ? 'Copy' : 'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/conversationtemplates' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}